import { Input } from "@/components/ui/input";

const InputField = ({
  value,
  placeholder,
  onChange,
  className,
}: {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  className: string;
}) => (
  <Input
    type="text"
    className={`${className}`}
    value={value}
    placeholder={placeholder}
    onChange={(e) => onChange(e.target.value)}
  />
);

export default InputField;
